export default "__VITE_ASSET__Ox6kodfI__"